/* globals Namespace */
(function (ns) {
    'use strict';

    var date = new Date(),
        month = date.toLocaleString('default', {month: 'long'}),
        year = date.getFullYear();
    if (document.getElementById('js-copyright-info') !== null) {
        document.getElementById('js-copyright-info').innerHTML += capitalizeFirstLetter(month) + '&nbsp;' + (year);
    }
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

}(Namespace));
